// Todo lo que vive en public/ se sirve bajo la base del sitio, que HOY es
// "/beta/" y el día del switch será "/". Escribir "/beta/..." a mano deja
// bombas de tiempo: con BASE_URL basta cambiar `base` en vite.config.ts.
const BASE = import.meta.env.BASE_URL;

/** ¿La app cuelga de un subdirectorio (la beta) o ya es la de la raíz? */
export const enSubdirectorio = BASE !== "/";

/** Ruta de un archivo de public/ (sin barra inicial: "logo-kex.png"). */
export function publico(archivo: string): string {
  return BASE + archivo;
}

/**
 * react-router quiere el basename SIN barra final; Vite siempre entrega
 * BASE_URL CON ella. Sin este recorte el router deja de resolver las rutas.
 */
export const basenameRouter = BASE.replace(/\/$/, "") || "/";


/**
 * El título de la pestaña. Mientras la app viva en /beta se anuncia como beta;
 * el día que ocupe la raíz toma el título de producción. Se aplica desde
 * main.tsx: index.html trae uno estático solo para que la pestaña no salga en
 * blanco mientras carga el JavaScript.
 */
export const TITULO = enSubdirectorio ? "KEX Radar (beta)" : "KEX · Panel de Leads";
